export const GROUPS = [
  { label: "G1", value: "G1" },
  { label: "G2", value: "G2" },
  { label: "G3", value: "G3" },
  { label: "G4", value: "G4" },
  { label: "G5", value: "G5" },
  { label: "G6", value: "G6" },
  { label: "G7", value: "G7" },
  { label: "G8", value: "G8" },
  { label: "G9", value: "G9" },
  { label: "G10", value: "G10" },
  { label: "G11", value: "G11" },
  { label: "G12", value: "G12" },
  { label: "G13", value: "G13" },
  { label: "G14", value: "G14" },
  { label: "G15", value: "G15" },
  { label: "G16", value: "G16" },
  { label: "G17", value: "G17" },
  { label: "G18", value: "G18" },
  { label: "G19", value: "G19" },
  { label: "G20", value: "G20" },
  { label: "G21", value: "G21" },
  { label: "G22", value: "G22" },
  { label: "G23", value: "G23" },
  { label: "G24", value: "G24" },
  { label: "G25", value: "G25" },
  { label: "G26", value: "G26" },
  { label: "G27", value: "G27" },
  { label: "G28", value: "G28" },
  { label: "G29", value: "G29" },
  { label: "G30", value: "G30" },
  { label: "G31", value: "G31" },
  { label: "G32", value: "G32" },
  { label: "G33", value: "G33" },
  { label: "G34", value: "G34" },
  { label: "G35", value: "G35" },
  { label: "G36", value: "G36" },
  { label: "G37", value: "G37" },
  { label: "G38", value: "G38" },
  { label: "G39", value: "G39" },
  { label: "G40", value: "G40" },
  { label: "G41", value: "G41" },
  { label: "G42", value: "G42" },
  { label: "G43", value: "G43" },
  { label: "G44", value: "G44" },
  { label: "G45", value: "G45" },
  { label: "G46", value: "G46" },
  { label: "G47", value: "G47" },
  { label: "G48", value: "G48" },
  { label: "G49", value: "G49" },
  { label: "G50", value: "G50" },
  { label: "G51", value: "G51" },
  { label: "G52", value: "G52" },
  { label: "G53", value: "G53" },
  { label: "G54", value: "G54" },
  { label: "G55", value: "G55" },
  { label: "G56", value: "G56" },
  { label: "G57", value: "G57" },
  { label: "G58", value: "G58" },
  { label: "G59", value: "G59" },
  { label: "G60", value: "G60" },
  { label: "G61", value: "G61" },
  { label: "G62", value: "G62" },
  { label: "G63", value: "G63" },
  { label: "G64", value: "G64" },
  { label: "G65", value: "G65" },
  { label: "G66", value: "G66" },
  { label: "G67", value: "G67" },
  { label: "G68", value: "G68" },
  { label: "G69", value: "G69" },
  { label: "G70", value: "G70" },
  { label: "G71", value: "G71" },
  { label: "G72", value: "G72" },
  { label: "G73", value: "G73" },
  { label: "G74", value: "G74" },
  { label: "G75", value: "G75" },
  { label: "G76", value: "G76" },
  { label: "G77", value: "G77" },
  { label: "G78", value: "G78" },
  { label: "G79", value: "G79" },
  { label: "G80", value: "G80" },
  { label: "G81", value: "G81" },
  { label: "G82", value: "G82" },
  { label: "G83", value: "G83" },
  { label: "G84", value: "G84" },
  { label: "G85", value: "G85" },
  { label: "G86", value: "G86" },
  { label: "G87", value: "G87" },
  { label: "G88", value: "G88" },
  { label: "G89", value: "G89" },
  { label: "G90", value: "G90" },
  { label: "G91", value: "G91" },
  { label: "G92", value: "G92" },
  { label: "G93", value: "G93" },
  { label: "G94", value: "G94" },
  { label: "G95", value: "G95" },
  { label: "G96", value: "G96" },
  { label: "G97", value: "G97" },
  { label: "G98", value: "G98" },
  { label: "G99", value: "G99" },
  { label: "G100", value: "G100" },
]